export const apiendpoints = {
  LOGIN_API: "/Account/Login",
  LOGIN_2FA_API: "/Account/LoginWith2fa",
  LOGIN_OTP_API: "/Account/VerifyOtp",
  SIGNUP_API: "/Account/Signup",
  SIGNOUT_API: "/Account/Logout",
  FORGOTPASSWORD_API: "/Account/ForgotPassword",
  RESET_PASSWORD_API: "/password/reset/",
  GET_BUSINESSPROFILE_BY_ID_API: "/BusinessProfile/GetBusinessProfileById",
  UPDATE_BUSINESSPROFILE_API: "/BusinessProfile/BusinessProfileUpdate",
  UPDATE_BUSINESS_LOGO_IMAGE_API: "/BusinessProfile/BusinessLogoImageUpdate",
  UPDATE_BUSINESS_PROFILE_COVER_API:
    "/BusinessProfile/BusinessProfileCoverUpdate",
  UPLOAD_BUSINESS_PROFILE_MULTI_DOCS_API:
    "/BusinessProfile/BusinessProfileMultipleDocsUpload",

  GET_USERPROFILE_BY_ID_API: "/UserProfile/GetUserProfileById",
  UPDATE_USERPROFILE_ADD_API: "/UserProfile/UserProfileAdd",
  UPDATE_USERPROFILE_UPDATE_API: "/UserProfile/UserProfileUpdate",
  UPDATE_USERPROFILE_IMAGE_API: "/UserProfile/UserProfileImageUpdate",

  //Subscription EndPoint
  SUB_MAST_SUB_LIST_API: "/SubscriptionMaster/SubscriptionList",
  SUB_MAST_GET_SUB_BY_ID_API: "/SubscriptionMaster/GetSubscriptionById",
  SUB_MAST_SUB_UPDATE_API: "/SubscriptionMaster/SubscriptionUpdate",
  SUB_PLAN_BUY_API: "/Subscription/SubscriptionPlanBuy",
  SUB_DETAILS_BY_USER_ID_API: "/Subscription/SubscriptionDetailsByUserId",
  SUB_LIST_API: "/SubscriptionMaster/ActiveSubscriptionList",
  SUB_PLAN_ENQUIRY_API: "/Subscription/SubscriptionEnquiry",

  //*****  Contract Endpoint **********
  MANAGE_CONTRACT_LIST_API: "/ManageContract/ManageContractList",
  MANAGE_CONTRACT_BY_ID_API: "/ManageContract/GetManageContractById",
  MANAGE_CONTRACT_UPDATE_API: "/ManageContract/ManageContractUpdate",
  MANAGE_CONTRACT_BY_EVENT_ID:
    "/ManageEventContract/GetManageEventContractByEventId",

  //****** FeedBack Report ***********
  MANAGE_FEEDBACK_REPORT: "/Feedback/GetFeedbackReportByBusinessId",

  // ******** Transtion Report ****************
  MANAGE_ORGANIZER_TRANSTION_REPORT: "/Admin/GetAllOrganizerPaymentDetails",
  MANAGE_TRADER_TRANSION_REPORT: "/Admin/GetAllTradersPaymentDetails",
  MANAGE_TICKET_TRANSTION_REPORT: "/EventTicket/GetOrganizerTransactions",
  MANAGE_TICKET_TRANSTION_REPORT_ADMIN:
    "/EventTicket/GetTicketTransactionsAdmin",
  GET_ALL_INVOCIE_ADMIN: "/Invoice/GetInvoicesAdmin",

  MANAGE_EVENT_PITCH_SALE_REPORT: "/Admin/GetEventPitchSaleSummary",
  MANAGE_EO_EVENT_PITCH_SALE_REPORT: "/Admin/GetEOEventPitchSaleSummary",

  //****** GLOBAL IN EVENT  */
  MANAGE_EVENT_GLOBAL_LIST: "/GlobalSetting/GetGlobalSettingByEventId",
  MANAGE_EVENT_GLOBAL_BYID: "/GlobalSetting/GetGlobalSettingById",
  MANAGE_EVENT_GLOBAL_UPDATE: "/GlobalSetting/GlobalSettingUpdate",

  MANAGE_PAYMENT_TERM_AND_CONDITION: "/GlobalSetting/GetTermsAndConditions",

  //**** Static Page Content ************
  MANAGE_ALL_STATIC_PAGE: "/ManageStaticPage/GetAllStaticPages",
  MANAGE_STATIC_PAGE_BY_URL: "/ManageStaticPage/GetStaticPageByUrl",
  MANAGE_STATIC_PAGE_UPDATE: "/ManageStaticPage/UpdateStaticPage",

  //*** FAQ Endpints *******************
  MANAGE_GET_ALL_FAQ: "/FAQ/GetAllFAQs",
  MANAGE_GET_BY_ID_FAQ: "/FAQ/GetFAQById",
  MANAGE_ADD_UPDATE_FAQ: "/FAQ/FAQAddUpdate",
  MANAGE_FAQ_DELETE: "/FAQ/DeleteFAQ",

  //****** Sales And Audience **********
  MANAGE_AUDIENCE: "/Events/EventTotalAudienceUpdate",

  MANAGE_SALES_BYID: "/EventPostSales/GetEventPostSalesDetailsByEventId",
  MANAGE_SALES_ADD: "/EventPostSales/EventPostSalesAdd",
  MANAGE_SALES_DELETE: "/EventPostSales/EventSalesDelete",

  //******  Invoice Api Endpoint */
  MANAGE_INVOICE_ADD_API: "/Invoice/InvoiceAdd",
  MANAGE_InvoiceApplicationId_API: "/Invoice/GetInvoiceByApplicationId",

  MANAGE_INVOICE_DETAILS_ADD_API: "/Invoice/InvoiceDetailAdd",
  MANGE_GETINVOICE_DETAILS_BY_ID_API:
    "/Invoice/GetInvoiceDetailByApplicationId",

  MANAGE_INVOICE_MAIN: "/Invoice/GetInvoice",

  //*******open Sign API ENDPOINT ********/
  OPEN_SIGN_API: "/OpenSign/save-document-detail",

  //******* Change Password ************/
  USER_PROFILE_CHANGE_PASSWORD: "/UserProfile/ChangePassword",

  //****** Notification  ************/
  MANAGE_GET_NOTIFICATION_USERID: "/Notification/get-notifications",
  MANAGE_GET_NOTIFICATION_ID: "/Notification/get-notification",
  MANAGE_UPDATE_READ_STATUS: "/Notification/UpdateReadStatus",
  MANAGE_UNREAD_MESSAGE_COUNT_FOR_USER:
    "/Notification/UnreadMessagesCountForUser",
  SEND_NOTIFICATION_AS_EMAIL: "/Notification/MessageNotificationSendEmail",

  //******* ShopFront ENDPOINT ******
  MANAGE_SHOPFRONT_LIST_API: "/ShopFront/GetAllShopFrontProducts",
  MANAGE_SHOPFRONT_DELETE_API: "/ShopFront/DeleteShopFrontProduct",
  MANAGE_SHOPFRONT_ADD_API: "/ShopFront/AddEditShopFrontProduct",
  MANAGE_SHOPFRONT_BY_ID_API: "/ShopFront/GetShopFrontProductById",

  //***** Event Contract Endpoint *****
  MANAGE_EVENT_CONTRACT_LIST_API:
    "/ManageEventContract/ManageEventContractList",
  MANAGE_EVENT_CONTRACT_BY_ID_API:
    "/ManageEventContract/GetManageEventContractById",
  MANAGE_EVENT_CONTRACT_ADD_API: "/ManageEventContract/ManageEventContractAdd",
  MANAGE_EVENT_CONTRACT_UPDATE_API:
    "/ManageEventContract/ManageEventContractUpdate",

  MANAGE_EVENT_CONTRACT_FORFINAlEMAILADD_API:
    "/ManageEventContract/ManageEventContractForFinalEmailAdd",

  MANAGE_EVENT_CONTRACT_FOR_Term_And_Condition_API:
    "/ManageEventContract/ManageEventContractForTermsAndConditionAdd",

  MANAGE_EVENT_CONTRACT_FOR_HandBooks_API:
    "/ManageEventContract/ManageEventContractForHandBookAdd",

  //***** Event Document Endpoint **********
  EVENT_DOCUMENT_LIST_API: "/EventDocument/EventDocumentList",
  EVENT_DOCUMENT_BY_ID_API: "/EventDocument/GetEventDocumentById",
  EVENT_DOCUMENT_UPDATE_API: "/EventDocument/EventDocumentUpdate",
  EVENT_DOCUMENT_ADD_API: "/EventDocument/EventDocumentAdd",
  EVENT_DOCUMENT_DELETE_API: "/EventDocument/DeleteEventDocument",
  EVENT_DOCUMENT_EVENT_BY_ID: "/EventDocument/GetEventDocumentByEventId",
  EVENT_APPLICATION_DOCUMENT_ADD: "EventDocument/EventApplicationDocumentAdd",
  EVENT_Get_Event_ApplicationDocument_ByApplicationId:
    "EventDocument/GetEventApplicationDocumentByApplicationId",
  EVENT_SENT_TICKET_INVOICE_BY_APPLICATION_ID:
    "EventDocument/SendEventTicketInvoiceByApplicationId",
  //***** Event Map Endpoint ***************
  EVENT_MAP_BY_ID_API: "/EventMap/GetEventMapsByEventId",
  EVENT_MAP_UPDATE_API: "/EventMap/EventMapUpdate",
  EVENT_MAP_ADD_API: "/EventMap/EventMapAdd",
  DOCTYP_LIST_API: "/DocumentTypeMaster/DocumentTypeList",
  GET_DOCTYPE_BY_ID_API: "/DocumentTypeMaster/GetDocumentTypeById",
  DOCTYP_ADD_API: "/DocumentTypeMaster/DocumentTypeAdd",
  DOCTYP_UPDATE_API: "/DocumentTypeMaster/DocumentTypeUpdate",

  COUNTRY_LIST_API: "/CountryMaster/CountryList",

  //******* Contact-US (Enquiry) *******************/
  CONTACT_US_LIST_API: "/ContactUs/ContactUsList",
  CONTACT_US_GET_BY_ID_API: "/ContactUs/GetContactUsById",
  CONTACT_US_ADD_API: "/ContactUs/ContactUsAdd",
  CONTACT_US_REPLY_API: "/ContactUs/ContactUsReply",
  CONTACT_US_VERIFYCAPTCHA_API: "/ContactUs/VerifyCaptcha",

  EVENT_CATEGORY_LIST: "/EventCategoryMaster/EventCategoryList",
  EVENT_ACTIVE_CATEGORY_LIST: "/EventCategoryMaster/ActiveEventCategoryList",
  GET_EVENT_CATEGORY_BY_ID: "/EventCategoryMaster/GetEventCategoryById",
  EVENT_CATEGORY_ADD: "/EventCategoryMaster/EventCategoryAdd",
  EVENT_CATEGORY_UPDATE: "/EventCategoryMaster/EventCategoryUpdate",
  EVENT_ADD_UPDATE: "/Events/EventsAddUpdate",
  EVENT_STATUS_ENUM_LIST: "/Enums/EventStatusEnumList",
  GET_EVENT_BY_ID: "/Events/GetEventById",
  GET_EVENT_BY_URL: "/Events/EventsBasisOnURL",
  GET_EVENT_APPLICATION_SATUS: "/Events/GetEventApplicationStatus",
  GET_EVENT_APPLICATION_SATUS_BY_TYPE:
    "/Events/GetEventApplicationStatusByType",
  GET_UPCOMING_EVENTS: "/Events/GetUpcomingEvent",
  GET_EVENT_BY_CATEGORY_ID: "/Events/GetEventByCategoryId",
  GET_EVENTS_BY_USER_ID: "/Events/EventsListBasisOfUserId",
  GET_EVENTS_BY_TRADER_ID: "/Events/EventsListBasisOnTraderId",
  EVENT_UPLOAD_IMAGES: "/Events/EventImageUpload",
  GET_EVENT_LOGO_BASE_IMAGE_BY_ID: "/Events/GetEventLogoBase64Image",
  TIMEZONE_ENUM_LIST: "/Enums/TimezoneEnumList",
  APPLICATION_ROLE_LIST: "/Enums/ApplicationForList",
  GENDER_ENUM_LIST: "/Enums/GenderEnumList",
  EVENT_APPLICATION_ADD: "/EventApplication/EventsApplicationAdd",
  EVENT_APPLICATION_UPDATE: "/EventApplication/EventsApplicationUpdate",
  GET_EVENT_APPLICATION: "/EventApplication/EventsApplication",
  GET_EVENT_APPLICATION_ID: "/EventApplication/EventsApplicationById",
  EVENT_APPLICATION_UPLOAD_IMAGE:
    "/EventApplication/EventApplicationImageUpload",
  EVENT_PITCH_ADD: "EventPitch/EventPitchAdd",
  EVENT_PITCH_UPDATE: "EventPitch/EventPitchUpdate",
  EVENT_PITCH_REDUCE_PRICE: "EventPitch/EventPitchReducePrice",
  GET_EVENT_PITCHES: "EventPitch/EventsPitchList",
  GET_PITCH_BY_ID: "EventPitch/GetEventPitchById",
  //Event Units API
  EVENT_UNIT_LIST: "/EventUnit/EventsUnitList",
  EVENT_UNIT_ADD_UPDATE: "/EventUnit/EventUnitAddUpdate",
  EVENT_UNIT_REDUCE_PRICE: "/EventUnit/EventUnitReducePrice",
  EVENT_UNIT_BY_ID: "/EventUnit/GetEventUnitById",
  GET_GLOBAL_SETTINGS_LIST: "GlobalSetting/GlobalSettingList",
  GET_PITCH_STATUS_LABEL: "GlobalSetting/GetPitchStatusLabels",  
  UPDATE_GLOBAL_SETTINGS: "GlobalSetting/GlobalSettingUpdate",
  ADD_RETAIL_APPLICATION: "EventApplicationRetail/EventApplicationRetailAdd",
  UPDATE_RETAIL_APPLICATION:
    "EventApplicationRetail/EventApplicationRetailUpdate",
  GET_RETAIL_APPLICATION_BY_ID:
    "EventApplicationRetail/GetEventApplicationRetailById",
  GET_RETAIL_APPLICATION_BY_EVENT_AND_USERID:
    "EventApplicationRetail/GetRetailApplicationByEventAndUserId",
  GET_RETAIL_APPLICATION_BY_PITCH_AND_USERID:
    "EventApplicationRetail/GetRetailApplicationByPitchAndUserId",
  //cater application form End points
  CATER_FORM_GET_BY_ID:
    "EventApplicationCateres/GetEventApplicationCateresById",
  CATER_FORM_ADD: "EventApplicationCateres/EventApplicationCateresAdd",
  CATER_FORM_UPDATE: "EventApplicationCateres/EventApplicationCatersUpdate",
  CATER_FORM_FILLED_BY_TRADER:
    "EventApplicationCateres/GetEventApplicationCateresFillByTrader",
  GET_CATER_APPLICATION_BY_UNIT_AND_USERID:
    "EventApplicationCateres/GetCaterApplicationByUnitAndUserId",
  CATER_UNIT_UPDATE: "EventApplicationCateres/EventAppCatersDtlUpdate",
  CATER_UNIT_ADD: "EventApplicationCateres/EventAppCatersDtlAdd",
  CATER_UNIT_REMOVE_BY_ID:
    "EventApplicationCateres/EventApplicationCatersDtlRemove",
  GET_CATER_PAYMENT_BY_APP_ID:
    "EventApplicationCateres/GetEventApplicationCatersPayment",
  CATER_DOC_UPLOAD: "EventApplicationCateres/EventAppCatersDocsUpload",
  CATER_DOC_WRITE: "EventApplicationCateres/EventAppCatersDocumentWrite",
  CATER_DOC_REMOVE: "EventApplicationCateres/EventAppCatersDocRemove",
  GET_CATER_DOC_BY_ID: "EventApplicationCateres/GetEventAppCatersDocById",
  USER_ROLE_ENUM_LIST: "/Enums/RolesEnumList",
  SUBSCRIBE_NEWSLETTER_API: "NewsLetter/NewsLetter",
  EVENT_MAP_API: "EventMap/GetEventMapsByEventId",
  EVENT_DOCUMENT_API: "EventDocument/GetEventDocumentById",
  EVENT_TRADERS_API: "Events/GetApprovedTradersByEventId",
  GET_MY_RETAIL_APPLICATIONS_BY_USERID:
    "EventApplication/MyApplicationForCatersAndRetailers",
  GET_SUBMIT_APP_BY_RETAILER:
    "EventApplication/SubmittedEventApplicationForRetailers",
  GET_SUBMIT_APP_BY_CATERER:
    "EventApplication/SubmittedEventApplicationForCaters",
  GET_CHATBOT_QUESTIONS: "/Question/QuestionList",
  GET_EVENT_BUSINESS_PROFILES: "/Feedback/GetAllBusinessForEvent",
  GET_EVENT_BUSINESS_PROFILE_BY_ID: "/Feedback/GetBusinessProfileDetails",
  GET_TRADER_REVIEWS_REPORT: "/Feedback/GetFeedbackReportByTraderId",
  GET_BUSINESS_REVIEWS_BY_ID: "/Feedback/get-feedbacks",
  SUBMIT_REVIEW: "/Feedback/AddUpdateFeedback",
  //admin api routes
  GET_ORGANIZERS: "/Admin/GetAllBusinessProfile",
  GET_ORGANIZER_BY_ID: "/Admin/GetProfileDetailsById",
  /*payment strip endpoints */
  CREAT_STRIPE_ACCOUNT: "StripeConnect/create-connected-Account",
  CREAT_STRIPE_LINK: "StripeConnect/create-account-link",
  CREAT_STRIPE_CHECKOUT_SESSION: "StripeConnect/create-checkout-session",
  CREAT_STRIPE_PAYMENT_INTENT: "StripeConnect/create-payment-intent",
  CREATE_STRIPE_TICKET_PAYMENT_INTENT:
    "StripeConnect/create-payment-intent-for-buy-ticket",
  CONFIRM_STRIPE_PAYMENT_INTENT: "StripeConnect/confirm-payment-intent",
  CONFIRM_STRIPE_TICKET_PAYMENT_INTENT: "EventTicket/EventTicketBuyTicket",
  CAPTURE_STRIPE_PAYMENT_INTENT: "StripeConnect/capture-payment-intent",
  GET_STRIPE_CONNECTED_ACCOUNT: "StripeConnect/get-connected-account",
  GET_STRIPE_PAYMENT_INTENT: "StripeConnect/get-payment-intent",
  GET_STRIPE_ACCOUNT_BY_USERID:
    "StripeConnect/get-connected-account-by-user-id",
  GET_STRIPE_ACCOUNT_BY_EVENTID:
    "StripeConnect/get-connected-account-by-event-id",
  GET_STRIPE_PAYMENT_BY_ID: "StripeConnect/get-stripe-payment-by-id",
  DELETE_STRIPE_ACCOUNT_BY_USERID:
    "StripeConnect/delete-connected-account-by-user-id",
  STRIPE_WEBHOOK: "StripeConnect/webhook",
  SAVE_PAYMENT: "StripeConnect/save-payment-intent",
  SAVE_BANK_PAYMENT: "StripeConnect/save-bank-payment-intent",
  UPDATE_PAYMENT: "StripeConnect/update-payment-intent",
  CAPTURE_PAYMENT_BY_APP_ID: "StripeConnect/capture-payment-intent-by-appId",
  CANCEL_PAYMENT_BY_APP_ID: "StripeConnect/cancel-payment-intent-by-appId",
  GET_RETAIL_APP_PAY_DETLS_BY_ID:
    "EventApplicationRetail/GetEventApplicationRetailPayment",
  UPDATE_RETAIL_APPLICATION_STATUS:
    "EventApplicationRetail/EventApplicationRetailUpdateStatus",
  UPDATE_CATERER_APPLICATION_STATUS:
    "EventApplicationCateres/EventApplicationCatersUpdateStatus",
  UPDATE_ORGANIZER: "/Admin/UpdateBusinessProfile",
  PROFILE_APPROVAL: "/Admin/HandleProfileApproval",
  GET_TRADERS: "/Admin/GetAllTradersBusinessProfile",
  CHANGE_PASSWORD_ADMIN: "/Admin/ChangePassword",
  GET_ALL_FEEDBACKS: "/Admin/GetFeedbackList",
  GET_PAYMENTS: "/Admin/GetAllPaymentDetails",
  GET_TRADER_APPLICATION_STATUS: "/EventApplication/GetTraderApplicationStatus",
  GET_SUBMITTED_APPLICATION_COUNT_BY_EVENTID:
    "/Events/GetSubmittedApplicationCountByEventId",
  ADD_EDIT_PITCH_ALLOCATION: "/EventApplicationRetail/AddEditPitchAllocation",
  ADD_EDIT_UNIT_ALLOCATION: "/EventApplicationCateres/AddEditUnitAllocation",
  EVENT_UPDATE_STATUS: "/Events/UpdateEventStatus",
  GET_EO_BUSINESS_PROFILE_BY_EVENT_ID:
    "/Events/GetEventOrganizerBusinessProfileByEventId",

  // tickets
  GET_EVENT_TICKET_BY_ID: "/EventTicket/GetEventTicketDetails",
  CREATE_EVENT_TICKET: "/EventTicket/EventTicketAddUpdate",
  GET_TICKET_BY_EVENT_ID: "/EventTicket/GetEventTicketDetailsByEventId",
  GET_TICKET_ELIGIBILITY: "/EventTicket/CheckTicketEligibility",
  GET_TICKET_INSIGHTS_BY_EVENT_ID: "/EventTicket/TicketsBoughtBasisOnEventId",
  EVENT_CAT_ORDER_UPDATE: "/EventCategoryMaster/EventCategoryOrderUpdate",
  GET_APP_PAYMENT_STATAU_BY_ID:
    "StripeConnect/get-payment-status-by-applicationId",
  GET_ALL_TRADER_UNIT: "Unit/GetAllUnits",
  GET_TRADER_UNIT_BY_ID: "Unit/GetUnitById",
  UPDTAE_TRADER_UNIT: "Unit/AddEditUnit",
  GET_TRADER_UNIT_BY_TRADERID: "Unit/GetAllUnitsByUserId",
  GET_ACTIVE_UNIT_BY_TRADERID: "Unit/GetActiveUnitsByUserId",
  GET_ACTIVE_UNIT_DOCUMENTS_BY_UNIT_ID: "Unit/GetActiveDocumentsByUnitId",
  GET_ACTIVE_UNIT_SHOPFRONTS_BY_UNIT_ID: "Unit/GetActiveShopFrontsByUnitId",
  UPLOAD_TRADER_UNIT_IMAGE: "Unit/UploadUnitImage",
  GET_TRADER_UNIT_DOCUMENTS: "/Unit/UnitDocumentList",
  GET_TRADER_UNIT_DOCUMENT_BY_ID: "/Unit/GetUnitDocumentById",
  GET_TRADER_UNIT_DOCUMENT_BY_UNIT_ID: "/Unit/GetUnitDocumentByUnitId",
  DELETE_TRADER_UNIT_DOCUMENT: "/Unit/DeleteUnitDocument",
  UPDATE_TRADER_UNIT_DOCUMENT: "/Unit/UnitDocumentAddUpdate",
  GET_TRADER_UNIT_SHOPFRONT: "/Unit/GetShopFrontProductsInUnit",
  ADD_TRADER_UNIT_SHOPFRONT: "/Unit/AddUnitProducts",
  DELETE_TRADER_UNIT_SHOPFRONT: "/Unit/DeleteUnitShopFrontProduct",
  GET_TRADER_SHOPFRONT: "/ShopFront/GetTraderShopFrontProducts",
  ACTIVE_DOCUMENT_TYPE_LIST: "/DocumentTypeMaster/ActiveDocumentTypesList",
  UPDATE_RETAIL_APP_DOCUMENT: "/Unit/SelectRetailUnitDocuments",
  UPDATE_CATERER_APP_DOCUMENT: "/Unit/SelectCaterUnitDocuments",
  RETAIL_DOC_REMOVE: "EventApplicationRetail/EventAppRetailDocRemove",
  GET_RETAIL_APP_DOCS: "EventApplicationRetail/GetRetailDocumentsByAppId",
  GET_CATER_APP_DOCS: "EventApplicationCateres/GetCaterDocumentsByAppId",
  GET_ADMIN_ALL_EVENTS: "Events/GetAllEvents",
  GET_ADMIN_EVENTS_APPROVAL: "Events/GetAllEventsPendingApproval",
  GET_EVENT_APPLICTION_STATUS_BY_PITCHID:
    "/EventPitch/GetEventApplicationStatusByPitchId",
  GET_RETAIL_AVAILABLE_PITCH_STATUS:
    "/EventApplicationRetail/GetAvailablePitchesStatus",
  GET_CATERER_AVAILABLE_PITCH_STATUS:
    "/EventApplicationCateres/GetAvailablePitchesStatus",
  GET_ADMIN_SUB_ENQ: "/Subscription/GetActiveSubscriptionEnquiry",
  UPDATE_ADMIN_SUB_ENQ: "/Subscription/UpdateSubscriptionEnquiryStatus",
  GET_ADMIN_USER_APPROVAL: "/Account/GetApproveRejectUsers",
  UPDATE_ADMIN_USER_APPROVAL: "/Account/ApproveRejectUser",
  TICKET_REFUND: "/EventTicket/RefundEventTicket",
  RETAIL_APPLICATION_REBID:
    "/EventApplicationRetail/EventApplicationRetailRebid",
  CATERS_APPLICATION_REBID:
    "/EventApplicationCateres/EventApplicationCatersRebid",

  STRIPE_DETAILS: "/GlobalSetting/GetStripeDetails",
  OPENSIGN_DETAILS: "/GlobalSetting/GetOpenSignDetails",
  FIRESTORE_DETAILS: "/GlobalSetting/GetFireBaseDetails",
  SWALLOWEO_DETAILS: "/GlobalSetting/GetSwallowEODetails",
  RECAPTCHA_DETAILS: "/GlobalSetting/GetRecaptchaDetails",

  REFRESH_TOKEN: "/Account/RefreshToken",
  ERROR_LOG: "/ErrorLog/ErrorLogAdd",
  EMAIL_CHANGE: "/Account/EmailChange",
  CONFIRM_EMAIL_CHANGE: "/Account/ConfirmEmailChange",
  CONFIRM_EMAIL:"/Account/CheckUserValid",
 REDEEM_EVENT_TCIKET: "/EventTicket/RedeemEventTicket",
};
